import { caseStudy } from "../lib/content";
import { ArrowRightIcon, CheckIcon } from "./Icons";
import SmartLink from "./SmartLink";

/**
 * The live site's savings chart. Bars show the shape of growth across the
 * months listed in `caseStudy.chartMonths`; only the headline total
 * (`caseStudy.stat`) is a published figure - no per-month values are invented.
 */
function SavingsChart() {
  const heights = [22, 34, 48, 58, 72, 86, 100];

  return (
    <div className="card p-6 shadow-card">
      <div className="flex items-baseline justify-between">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-muted">
            {caseStudy.stat.label}
          </p>
          <p className="mt-1 text-3xl font-extrabold tracking-tight text-accent-success">
            {caseStudy.stat.value}
          </p>
        </div>
        <span className="text-xs font-medium text-ink-muted">per month</span>
      </div>

      <div className="mt-6 flex h-40 items-end gap-2" aria-hidden="true">
        {heights.map((h, i) => (
          <div key={i} className="flex h-full w-full items-end">
            <div
              className="w-full rounded-t-md bg-gradient-to-t from-brand-300 to-brand-500"
              style={{ height: `${h}%` }}
            />
          </div>
        ))}
      </div>

      <div className="mt-3 flex justify-between text-[11px] font-medium text-ink-muted">
        {caseStudy.chartMonths.map((month) => (
          <span key={month}>{month}</span>
        ))}
      </div>
    </div>
  );
}

export default function CaseStudy() {
  return (
    <section id="case-study" className="section-pad bg-white">
      <div className="container-page">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_1fr] lg:items-center">
          <div>
            <span className="eyebrow">{caseStudy.eyebrow}</span>
            <h2 className="h-section mt-4">{caseStudy.heading}</h2>
            <p className="lead">{caseStudy.body}</p>

            <ul className="mt-8 space-y-3">
              {caseStudy.bullets.map((bullet) => (
                <li key={bullet} className="flex items-start gap-3 text-sm text-ink">
                  <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-success/15 text-accent-success">
                    <CheckIcon className="h-3 w-3" />
                  </span>
                  {bullet}
                </li>
              ))}
            </ul>

            <SmartLink href={caseStudy.cta.href} className="btn-primary mt-9">
              {caseStudy.cta.label}
              <ArrowRightIcon />
            </SmartLink>
          </div>

          <SavingsChart />
        </div>
      </div>
    </section>
  );
}
